import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function FindingCard({ finding, onImageClick, showStore }) {
    const [imgError, setImgError] = useState(false);
    const navigate = useNavigate();

    const timeStr = finding.createdAt
        ? new Date(finding.createdAt).toLocaleString()
        : "";

    const handleCardClick = () => {
        if (finding.imageUrl && onImageClick) {
            onImageClick(finding.imageUrl);
        } else if (finding.siteId) {
            navigate(`/store/${finding.siteId}?tab=findings`);
        }
    };

    return (
        <div className="finding-card" onClick={handleCardClick} style={{ cursor: "pointer" }}>
            <div className="finding-card-header">
                <span className={`severity ${(finding.severity || "").toLowerCase()}`}>
                    {finding.severity}
                </span>
                <span className="finding-zone">{finding.zone}</span>
                {finding.category && (
                    <span className="finding-category">{finding.category}</span>
                )}
                {showStore && finding.siteId && (
                    <span style={{ marginLeft: "auto", fontSize: 12, color: "var(--text-muted)" }}>
                        #{finding.siteId}
                    </span>
                )}
            </div>
            {finding.imageUrl && !imgError ? (
                <div style={{ display: "flex", gap: 12, marginTop: 4 }}>
                    <img
                        src={finding.imageUrl}
                        alt={finding.description}
                        className="finding-thumbnail"
                        onClick={(e) => {
                            e.stopPropagation();
                            onImageClick && onImageClick(finding.imageUrl);
                        }}
                        onError={() => setImgError(true)}
                        style={{
                            width: 120,
                            height: 80,
                            objectFit: "cover",
                            borderRadius: 6,
                            border: "1px solid var(--border)",
                            flexShrink: 0,
                        }}
                    />
                    <div className="finding-description" style={{ flex: 1 }}>
                        {finding.description}
                    </div>
                </div>
            ) : (
                <div className="finding-description">{finding.description}</div>
            )}
            <div className="finding-meta">
                {timeStr}
                {finding.imageUrl && (
                    <span style={{ marginLeft: 12, color: "var(--accent)", fontSize: 12 }}>
                        ðŸ“· View image
                    </span>
                )}
                {!finding.imageUrl && finding.siteId && (
                    <span style={{ marginLeft: 12, color: "var(--accent)", fontSize: 12 }}>
                        View store â†’
                    </span>
                )}
            </div>
        </div>
    );
}

export default FindingCard;

